import { saveAs } from 'file-saver';

import type { CurrentUserHolder } from 'api/market-view-api';

import { downloadMarketViewAssetBlob } from 'hooks/client-asset-api';

export interface DownloadFileArgs {
  fileName: string;
  setLoading: (loading: boolean) => void;
  currentUser: CurrentUserHolder;
  clientId: string | number;
  fileId: string | number;
}

export const downloadFile = ({
  fileName,
  setLoading,
  currentUser,
  clientId,
  fileId,
}: DownloadFileArgs): void => {
  setLoading(true);

  downloadMarketViewAssetBlob({
    currentUserOktaId: currentUser.data.oktaUserId,
    clientId,
    fileId,
  })
    .then((blob: Blob) => {
      saveAs(blob, fileName);
    })
    .catch((error: unknown) => {
      console.error('Failed to download file:', error);
    })
    .finally(() => {
      setLoading(false);
    });
};
